import { CognitoUserPool } from 'amazon-cognito-identity-js';
const poolData = {
  UserPoolId:"us-east-2_SVakpvZsj",
  ClientId: "2pef1phu6o9ppsv1th4sndu2u9"
};
export default new CognitoUserPool(poolData);